export const articles = [
  {
    slug: 'nanfang-baoyu-yangzhi-jishu',
    title: '南方鲍鱼工厂化养殖全流程技术指南',
    category: 'yangzhi',
    categoryName: '鲍鱼养殖',
    summary: '详细解读南方鲍鱼工厂化养殖的苗种选育、水质管理、饲料投喂、病害防控等核心技术环节，适合养殖从业者学习参考。',
    content: `鲍鱼作为海产八珍之首，其养殖技术一直是水产养殖领域的热点话题。本文将为您详细解读南方鲍鱼工厂化养殖的全流程技术要点。

## 一、苗种选育

优质的苗种是养殖成功的基础。目前南方养殖的主要品种包括：

**皱纹盘鲍**：生长速度快，适应性强，是最主要的养殖品种。选择壳长2-3厘米、体质健壮、附着力强的幼鲍作为养殖苗种。

**杂色鲍**：肉质鲜美，市场价格较高，但生长速度相对较慢。

选苗时应关注以下几点：
- 外壳完整无损伤
- 触角反应灵敏
- 腹足吸附力强
- 个体大小均匀

## 二、养殖环境管理

### 水温控制
鲍鱼最适生长水温为15-22℃。冬季需加温，夏季需降温，温差变化不宜超过3℃/天。

### 水质要求
- 溶解氧：≥5mg/L
- 盐度：28-35‰
- pH值：7.8-8.2
- 氨氮：<0.2mg/L

### 换水管理
采用流水养殖模式，每日换水量为养殖水体的3-5倍。

## 三、饲料投喂

主要投喂新鲜海藻（海带、裙带菜、龙须菜等），也可搭配人工配合饲料。投喂量根据水温、鲍鱼规格和摄食情况灵活调整。一般日投喂量为鲍鱼体重的5-10%。

## 四、病害防控

坚持"预防为主、防治结合"的原则：
- 定期消毒养殖设施
- 加强水质监测
- 及时发现并隔离病鲍
- 合理使用微生态制剂

## 五、收获与运输

养殖周期通常为18-24个月，当鲍鱼达到商品规格（壳长6-8厘米）即可收获。活体运输需采用保温箱加冰袋的方式，确保运输过程中温度维持在10-15℃。`,
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20abalone%20aquaculture%20facility%20interior%20with%20rows%20of%20concrete%20tanks%20filled%20with%20clear%20seawater%2C%20young%20abalone%20visible%20on%20surfaces%2C%20professional%20marine%20farming%20environment%2C%20bright%20industrial%20lighting%2C%20clean%20and%20organized%20workspace%2C%20documentary%20style%20photography&width=800&height=600&seq=art-yangzhi-1&orientation=landscape',
    date: '2026-07-15',
    duration: '18:24',
    views: 12580,
  },
  {
    slug: 'beifang-dipai-baoyu-yangzhi',
    title: '北方底播增殖鲍鱼生态养殖模式探析',
    category: 'yangzhi',
    categoryName: '鲍鱼养殖',
    summary: '探索北方海域底播增殖鲍鱼的生态养殖模式，分析其环境友好型特点及经济效益，为海洋牧场建设提供参考。',
    content: `底播增殖是一种模仿鲍鱼自然生长环境的生态养殖方式。本文将深入探析北方海域底播增殖鲍鱼的技术模式与优势。

## 一、底播增殖概述

底播增殖是将人工培育的鲍鱼苗种投放到适宜的海域中，利用自然饵料和海洋环境条件进行生长的养殖方式。这种模式具有以下优势：

- 不占用陆地资源
- 无需投喂人工饲料
- 产品质量接近野生鲍鱼
- 有利于海洋生态修复

## 二、海域选择标准

选择底播海域时需考量：
- 水深：5-20米
- 底质：岩礁或砾石底质
- 海流：流速适中
- 水质：符合国家一类海水标准

## 三、苗种投放技术

### 投放季节
春季（4-5月）或秋季（9-10月），水温15-18℃为最佳投放窗口。

### 投放密度
根据海区饵料生物量确定，一般为5-10只/平方米。

## 四、日常管理

- 定期潜水巡查生长情况
- 监测海区环境变化
- 防止敌害生物侵害
- 记录生长数据

## 五、经济效益分析

底播增殖鲍鱼的市场价格通常为工厂化养殖鲍鱼的1.5-2倍，且养殖成本降低30%以上，具有良好的经济效益。`,
    thumbnail: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20coastal%20abalone%20sea%20ranching%20area%20with%20clear%20turquoise%20water%2C%20rocky%20shoreline%2C%20small%20fishing%20boats%2C%20sustainable%20marine%20aquaculture%2C%20beautiful%20natural%20seascape%2C%20drone%20photography%20with%20warm%20sunlight&width=800&height=600&seq=art-yangzhi-2&orientation=landscape',
    date: '2026-06-28',
    duration: '22:10',
    views: 8930,
  },
  {
    slug: 'qianshui-bulao-baoyu-jishi',
    title: '专业潜水员海底捕捞鲍鱼实况记录',
    category: 'bulao',
    categoryName: '鲍鱼捕捞',
    summary: '跟随资深潜水员深入海底，实拍记录野生鲍鱼捕捞全过程，展示专业捕捞装备使用技巧与安全规范。',
    content: `野生鲍鱼捕捞是一项需要专业技能和丰富经验的工作。本文带您深入了解专业潜水员的海底捕捞实况。

## 一、捕捞前准备

### 装备检查
- 潜水服：5mm或7mm湿式潜水服
- 氧气瓶：确保充足气量
- 鲍鱼刀：专用不锈钢撬刀
- 网袋：用于盛放收获鲍鱼
- 潜水电脑表：监测深度和时间

### 海域勘察
- 了解当日潮汐和海流情况
- 确定作业海域水深和底质
- 检查天气预报和海况信息

## 二、下潜作业

专业潜水员通常在水深8-25米的岩礁区域作业。下潜时需缓慢下降，给耳膜充分的适应时间。

### 寻找鲍鱼
鲍鱼通常附着在岩礁的背光面，颜色与岩石相近，需要经验丰富的潜水员仔细观察。判断要点：
- 圆形或椭圆形的外壳轮廓
- 壳面颜色多为深褐色或墨绿色
- 通常位于海藻茂盛的岩礁区域

## 三、捕捞技巧

捕捞鲍鱼的关键是"快、准、稳"：

1. 从鲍鱼后方或侧面接近
2. 将鲍鱼刀快速插入壳与岩石之间
3. 一次性撬离，避免反复操作
4. 立即放入网袋，防止逃脱

## 四、安全规范

- 严格遵守潜水时间限制
- 两人一组，互为安全观察
- 上升速度不超过18米/分钟
- 安全停留：5米处停留3分钟

## 五、可持续捕捞

遵循"捕大留小"原则，仅捕捞壳长超过法定标准的个体，确保渔业资源的可持续利用。`,
    thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20scuba%20diver%20underwater%20collecting%20wild%20abalone%20from%20rocky%20reef%2C%20clear%20blue%20ocean%20water%20with%20sunbeams%2C%20kelp%20forest%20background%2C%20adventure%20underwater%20photography%2C%20dramatic%20natural%20lighting%2C%20marine%20conservation%20theme&width=800&height=600&seq=art-bulao-1&orientation=landscape',
    date: '2026-07-08',
    duration: '25:36',
    views: 15670,
  },
  {
    slug: 'aozhou-baoyu-shangye-bulao',
    title: '澳大利亚南部海域商业鲍鱼捕捞作业全览',
    category: 'bulao',
    categoryName: '鲍鱼捕捞',
    summary: '走进澳大利亚南部海域，了解世界顶级鲍鱼产区的商业捕捞作业模式与管理体系。',
    content: `澳大利亚南部海域是全球最著名的鲍鱼产区之一，其严格的渔业管理制度和卓越的产品品质享誉世界。

## 一、澳大利亚鲍鱼渔业概况

澳大利亚南部海域主要产出的鲍鱼品种包括：

**黑唇鲍**：澳大利亚最具代表性的鲍鱼品种，壳表呈深绿至黑色，肉质紧实，味道鲜美。

**绿唇鲍**：壳缘呈现独特的绿色，体型较大，主要分布在塔斯马尼亚周边海域。

## 二、配额管理制度

澳大利亚实行严格的鲍鱼捕捞配额制度：

- 总可捕捞量由渔业科学家根据资源评估确定
- 配额按区域分配给持证捕捞者
- 每位捕捞者每年有明确的捕捞限额
- 超额捕捞将面临严厉处罚

## 三、捕捞作业规范

### 作业时间
- 捕捞季节：每年11月至次年5月
- 日作业时间：日出至午后
- 禁捕期严格遵守

### 捕捞装备
- 专用潜水装备
- GPS定位系统
- 电子计量设备
- 船上活水暂养舱

## 四、品质管控

捕捞上来的鲍鱼需在2小时内完成：
- 规格分选
- 称重记录
- 活体包装
- 冷链运输

## 五、出口加工

澳大利亚鲍鱼大部分出口至亚洲市场，主要加工形式包括：
- 鲜活出口
- 冷冻鲍鱼肉
- 干鲍
- 即食罐头`,
    thumbnail: 'https://readdy.ai/api/search-image?query=Commercial%20abalone%20fishing%20boat%20on%20Australian%20southern%20coast%20with%20crystal%20clear%20water%2C%20rugged%20coastline%20cliffs%2C%20professional%20fishing%20operation%2C%20bright%20sunny%20day%2C%20pristine%20ocean%20environment%2C%20documentary%20style%20marine%20photography&width=800&height=600&seq=art-bulao-2&orientation=landscape',
    date: '2026-06-20',
    duration: '30:15',
    views: 21200,
  },
  {
    slug: 'ganbao-jiagong-gongyi-quanjie',
    title: '传统干鲍加工工艺全解析：从鲜鲍到溏心干鲍',
    category: 'jiagong',
    categoryName: '鲍鱼加工',
    summary: '详解传统干鲍制作工艺，从鲜鲍挑选、去壳清洗、煮制晾晒到陈化储藏，揭秘溏心干鲍的形成奥秘。',
    content: `干鲍是鲍鱼加工制品中的极品，其制作工艺复杂，对原料和技艺要求极高。本文将为您全面解析传统干鲍加工工艺。

## 一、原料选择

制作优质干鲍的第一步是挑选上等鲜鲍：

**品种要求**：
- 首选皱纹盘鲍和南非鲍
- 壳长8厘米以上
- 肉质肥厚饱满

**新鲜度标准**：
- 触角反应灵敏
- 腹足吸附力强
- 肉质富有弹性

## 二、去壳取肉

### 工具准备
专用鲍鱼刀、不锈钢托盘、清洁毛巾

### 操作步骤
1. 用鲍鱼刀沿壳内壁插入
2. 切断闭壳肌与壳的连接
3. 将鲍鱼肉完整取出
4. 去除内脏和嘴巴
5. 用盐水清洗干净

## 三、腌制与定型

用3%盐水浸泡鲍鱼肉2-3小时，使其适度脱水并定型。之后用竹签串起，保持鲍鱼肉平整不卷曲。

## 四、晾晒脱水

### 第一阶段：日光晾晒
在晴朗天气下晾晒3-5天，每天翻面2-3次。

### 第二阶段：阴干
移至通风阴凉处继续干燥7-10天。

### 第三阶段：反复晾晒
根据天气情况反复日光晾晒和阴干，整个过程约需20-30天。

## 五、陈化储藏

干燥后的鲍鱼需在通风干燥环境中陈化3-6个月，这是形成溏心口感的关键阶段。陈化过程中：
- 温度控制在15-25℃
- 相对湿度控制在60-70%
- 定期翻动检查
- 防止虫蛀和霉变

## 六、品质鉴定

优质干鲍的特征：
- 表面呈现自然琥珀色光泽
- 质地坚硬，敲击有清脆声
- 泡发后恢复饱满形态
- 烹饪后中心呈现半透明溏心`,
    thumbnail: 'https://readdy.ai/api/search-image?query=Traditional%20dried%20abalone%20processing%20on%20bamboo%20trays%20drying%20under%20natural%20sunlight%2C%20artisan%20seafood%20craftsmanship%2C%20wooden%20workshop%20setting%2C%20golden%20amber%20colored%20dried%20abalone%2C%20traditional%20Chinese%20food%20processing%2C%20warm%20natural%20lighting%2C%20cultural%20heritage%20photography&width=800&height=600&seq=art-jiagong-1&orientation=landscape',
    date: '2026-07-01',
    duration: '20:48',
    views: 18920,
  },
  {
    slug: 'jishi-baoyu-jiagong-jishu',
    title: '即食鲍鱼现代化加工生产线全流程展示',
    category: 'jiagong',
    categoryName: '鲍鱼加工',
    summary: '走进现代化即食鲍鱼加工厂，展示从原料验收、清洗杀菌、调味烹制到真空包装的自动化生产全流程。',
    content: `即食鲍鱼是近年来市场增长最快的鲍鱼加工产品。本文带您走进现代化即食鲍鱼加工厂，了解自动化生产全流程。

## 一、原料验收

进入加工厂的鲜鲍需经过严格验收：
- 品种确认
- 规格分级
- 新鲜度检测
- 药物残留筛查
- 重金属检测

## 二、清洗与预处理

### 自动化清洗
采用高压喷淋和超声波联合清洗技术，彻底去除鲍鱼表面的污物和微生物。

### 去壳处理
机械化去壳设备可高效完成鲍鱼肉与壳的分离，产能可达每小时2000-3000只。

## 三、杀菌工艺

采用低温巴氏杀菌技术：
- 温度：75-85℃
- 时间：15-25分钟
- 既保证食品安全
- 又保持鲍鱼口感

## 四、调味与烹制

根据不同产品系列，采用标准化配方进行调味：
- 原味系列：仅添加少量食盐
- 红烧系列：酱油、冰糖、香料
- 鲍汁系列：浓汤熬制

## 五、真空包装

### 包装流程
1. 定量装袋
2. 真空抽气
3. 热封封口
4. 金属检测
5. 重量校验

## 六、杀菌与质检

包装后的产品进行二次杀菌处理，随后经过：
- 保温试验
- 微生物检验
- 感官评定
- 包装完整性检测

全部合格后方可出厂销售。`,
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20food%20processing%20factory%20production%20line%20for%20abalone%2C%20stainless%20steel%20machinery%2C%20workers%20in%20hygienic%20uniforms%2C%20automated%20packaging%20system%2C%20clean%20industrial%20environment%2C%20bright%20LED%20lighting%2C%20food%20safety%20standard%20facility&width=800&height=600&seq=art-jiagong-2&orientation=landscape',
    date: '2026-06-25',
    duration: '16:32',
    views: 11230,
  },
  {
    slug: 'baoyu-hongshao-jingdian-zuofa',
    title: '名厨亲授：红烧鲍鱼经典做法与火候掌控秘诀',
    category: 'pengren',
    categoryName: '鲍鱼烹饪',
    summary: '五星级酒店行政总厨亲自示范红烧鲍鱼的经典做法，从鲍鱼处理到汤汁调配，掌握火候控制的独门秘诀。',
    content: `红烧鲍鱼是中餐烹饪中的经典名菜，做好一道红烧鲍鱼，火候和调味是关键。本文特邀五星级酒店行政总厨分享独门秘诀。

## 一、食材准备

### 主料
- 鲜鲍鱼：6只（每只约80-100克）
- 或泡发好的干鲍：4只

### 辅料
- 老母鸡：半只（熬汤用）
- 金华火腿：50克
- 猪骨：200克
- 花菇：6朵

### 调味料
- 老抽：1汤匙
- 蚝油：2汤匙
- 冰糖：20克
- 料酒：2汤匙
- 姜片：5片
- 葱段：2根

## 二、鲍鱼初加工

### 鲜鲍处理
1. 用刷子刷洗鲍鱼表面
2. 去除内脏和嘴巴
3. 用盐水搓洗去黏液
4. 在鲍鱼表面切菱形花刀

### 干鲍泡发
干鲍需提前48小时泡发，期间换水4-5次，泡发至柔软有弹性。

## 三、高汤熬制

好汤是好菜的基础：
1. 老母鸡、猪骨焯水去血沫
2. 加入金华火腿、姜片
3. 大火煮沸转小火熬制4小时
4. 过滤取清汤备用

## 四、红烧烹饪

### 第一步：爆香
热锅冷油，爆香姜片和葱段。

### 第二步：煸炒鲍鱼
放入鲍鱼，两面略煎至微黄，烹入料酒去腥。

### 第三步：调味炖煮
加入高汤、老抽、蚝油、冰糖，大火煮沸后转小火慢炖：
- 鲜鲍：炖40-50分钟
- 干鲍：炖2-3小时

### 第四步：收汁
待鲍鱼软糯入味，转大火收汁至浓稠挂勺。

## 五、装盘与品鉴

将鲍鱼摆入预热过的餐盘，淋上浓稠的酱汁，配以焯水西兰花点缀。成品色泽红亮，鲍鱼肉质软糯弹牙，酱汁浓郁鲜香。`,
    thumbnail: 'https://readdy.ai/api/search-image?query=Gourmet%20braised%20abalone%20dish%20presented%20on%20elegant%20ceramic%20plate%20with%20rich%20dark%20sauce%2C%20professional%20chef%20hands%20garnishing%2C%20luxurious%20Chinese%20fine%20dining%2C%20steam%20rising%2C%20warm%20restaurant%20ambient%20lighting%2C%20Michelin%20star%20food%20photography&width=800&height=600&seq=art-pengren-1&orientation=landscape',
    date: '2026-07-10',
    duration: '14:55',
    views: 28760,
  },
  {
    slug: 'baoyu-qingzheng-jianyi-shiliang',
    title: '清蒸鲍鱼：最简约的做法，最纯粹的海味',
    category: 'pengren',
    categoryName: '鲍鱼烹饪',
    summary: '清蒸是品味鲍鱼原汁原味的最佳方式。学会这道家常做法，用最简单的烹饪手法呈现最高级的海洋鲜味。',
    content: `清蒸鲍鱼看似简单，却最能体现鲍鱼本身的鲜美。掌握好时间和火候，在家也能做出媲美餐厅的鲜嫩鲍鱼。

## 一、选材要点

清蒸对食材的新鲜度要求极高：
- 务必选用鲜活鲍鱼
- 壳长6-8厘米为佳
- 触感紧实、反应迅速

## 二、食材清单

- 鲜活鲍鱼：8只
- 姜丝：适量
- 葱丝：适量
- 蒸鱼豉油：2汤匙
- 料酒：1汤匙
- 食用油：2汤匙

## 三、处理步骤

### 清洗
1. 用刷子在流水下刷洗鲍鱼壳
2. 用小刀分离鲍鱼肉与壳
3. 去除内脏
4. 在鲍鱼肉表面轻划十字花刀

### 回壳
将处理好的鲍鱼肉放回壳中，这样蒸制时造型更美观。

## 四、蒸制

### 关键参数
- 蒸锅水开后再放入鲍鱼
- 大火蒸制
- 时间控制在5-6分钟
- 蒸好后立即取出，不可焖

## 五、调味

1. 倒掉盘中蒸出的汁水
2. 撒上姜丝和葱丝
3. 淋上蒸鱼豉油
4. 烧热油浇在葱姜丝上

## 六、品鉴要点

好的清蒸鲍鱼应该：
- 肉质洁白如玉
- 口感鲜嫩弹牙
- 汁水充盈不干柴
- 原味鲜甜无腥气

趁热享用，感受大海最纯粹的馈赠。`,
    thumbnail: 'https://readdy.ai/api/search-image?query=Steamed%20fresh%20abalone%20in%20shell%20on%20white%20ceramic%20plate%2C%20garnished%20with%20shredded%20ginger%20and%20green%20onions%2C%20hot%20oil%20being%20poured%20over%2C%20steam%20rising%2C%20clean%20minimalist%20food%20presentation%2C%20bright%20natural%20lighting%2C%20fresh%20seafood%20photography&width=800&height=600&seq=art-pengren-2&orientation=landscape',
    date: '2026-06-30',
    duration: '09:42',
    views: 34520,
  },
  {
    slug: 'quanqiu-baoyu-pinzhong-tujian',
    title: '全球主要鲍鱼品种图鉴：从外形到口感全面对比',
    category: 'jianbie',
    categoryName: '品种鉴别',
    summary: '图文并茂介绍全球十大主要鲍鱼品种，从外观特征、产地分布到口感风味，帮助您成为鲍鱼品鉴专家。',
    content: `全球已知鲍鱼品种超过100种，其中具有商业价值的约20种。本文将为您详细介绍最具代表性的鲍鱼品种。

## 一、皱纹盘鲍

**产地**：中国黄海、渤海及日本沿海
**特征**：壳面粗糙，有明显的螺旋纹和生长纹，壳色为深褐色或墨绿色。壳长可达15厘米。
**口感**：肉质紧实弹牙，鲜味浓郁
**市场定位**：中高端

## 二、杂色鲍

**产地**：中国南方沿海、东南亚
**特征**：壳面颜色丰富，以红色、棕色、绿色混合纹理为特点。体型相对较小，壳长约5-8厘米。
**口感**：肉质细嫩甘甜，回味悠长
**市场定位**：中端

## 三、黑唇鲍（澳大利亚）

**产地**：澳大利亚南部海域
**特征**：壳缘内侧为黑色，壳面呈深绿至黑色。体型硕大，壳长可达20厘米以上。
**口感**：肉质厚实有嚼劲，滋味醇厚
**市场定位**：高端

## 四、绿唇鲍（澳大利亚/新西兰）

**产地**：澳大利亚塔斯马尼亚、新西兰
**特征**：壳缘呈独特的翠绿色，壳面有放射状肋纹。壳长可达18厘米。
**口感**：肉质软嫩多汁，鲜甜中带奶香
**市场定位**：高端

## 五、南非鲍

**产地**：南非沿海
**特征**：壳面光滑呈浅褐色，壳形较圆。体型中等，壳长8-12厘米。
**口感**：肉质嫩滑，适合制作干鲍
**市场定位**：中高端

## 六、加州红鲍

**产地**：美国加利福尼亚沿海
**特征**：壳面呈独特的砖红色，壳形扁平宽大。壳长可达25厘米，为全球最大鲍鱼品种之一。
**口感**：肉质厚实，适合烧烤和煎制
**市场定位**：高端

## 七、选购建议

对于普通消费者：
- 日常食用：推荐杂色鲍或养殖皱纹盘鲍
- 宴请宾客：选择黑唇鲍或南非鲍
- 送礼佳品：干鲍（南非鲍制作的溏心干鲍）
- 尝鲜体验：绿唇鲍刺身`,
    thumbnail: 'https://readdy.ai/api/search-image?query=Collection%20of%20various%20abalone%20species%20shells%20displayed%20on%20aged%20wooden%20table%2C%20different%20sizes%20colors%20and%20patterns%2C%20natural%20history%20specimen%20style%2C%20educational%20display%2C%20soft%20window%20lighting%2C%20vintage%20scientific%20illustration%20aesthetic&width=800&height=600&seq=art-jianbie-1&orientation=landscape',
    date: '2026-06-18',
    duration: '26:18',
    views: 23100,
  },
  {
    slug: 'xianbao-ganbao-ruhe-tiaoxuan',
    title: '鲜鲍与干鲍挑选技巧大全：看闻摸捏四步法',
    category: 'jianbie',
    categoryName: '品种鉴别',
    summary: '学会看、闻、摸、捏四步挑选法，教您在海鲜明档前快速辨别鲜鲍品质，在干货铺里精准挑选优质干鲍。',
    content: `挑选优质鲍鱼需要掌握一定技巧。无论是鲜鲍还是干鲍，都可以通过看、闻、摸、捏四步方法来鉴别品质。

## 一、鲜鲍挑选四步法

### 第一步：看
- **看颜色**：鲜活鲍鱼肉色洁白或微黄，有自然光泽
- **看反应**：触碰鲍鱼肉，触角会迅速收缩
- **看完整度**：外壳完整无破损，裙边无残缺
- **看吸附力**：翻过来看腹足吸附情况

### 第二步：闻
- 新鲜鲍鱼有淡淡的海水清香
- 若有腥臭味或氨水味，说明不新鲜
- 若有化学药水味，可能经过药水浸泡

### 第三步：摸
- 触摸鲍鱼肉应有弹性，按压后迅速回弹
- 表面湿润但不黏滑
- 肉质紧实不松软

### 第四步：捏
- 轻捏鲍鱼腹足，感觉紧实有力
- 松软无力的鲍鱼新鲜度差
- 过于僵硬可能是死后僵直

## 二、干鲍挑选要点

### 外观鉴别
- **色泽**：自然琥珀色或黄褐色为佳
- **形状**：完整饱满，无明显凹陷
- **白霜**：表面有自然白色盐霜为正常
- **裂纹**：无开裂和大面积破损

### 质地判断
- 敲击有清脆声
- 手感沉重
- 质地坚硬紧实

### 等级划分
- **特级**：色泽金黄，形态饱满，裙边完整
- **一级**：色泽正常，形态规整，轻微瑕疵
- **二级**：色泽略暗，形态一般，有明显裂痕

## 三、选购时机

- 鲜鲍：秋冬季节肉质最肥美
- 干鲍：新货通常在上半年上市
- 避开台风季节购买，品质更稳定

## 四、保存方法

- 鲜鲍：0-5℃冷藏，48小时内食用
- 干鲍：密封后置于阴凉干燥处，可保存1-3年`,
    thumbnail: 'https://readdy.ai/api/search-image?query=Fresh%20abalone%20and%20dried%20abalone%20side%20by%20side%20on%20market%20stall%2C%20seafood%20market%20scene%2C%20customer%20examining%20quality%2C%20vibrant%20fresh%20seafood%20display%2C%20natural%20market%20lighting%2C%20authentic%20Asian%20wet%20market%20photography&width=800&height=600&seq=art-jianbie-2&orientation=landscape',
    date: '2026-07-05',
    duration: '13:20',
    views: 16780,
  },
  {
    slug: 'baoyu-yingyang-jiazhi-jiexi',
    title: '鲍鱼营养价值全面解析：为什么被称为海洋软黄金',
    category: 'yingyang',
    categoryName: '营养科普',
    summary: '从蛋白质、氨基酸、矿物质到活性成分，科学解析鲍鱼的营养价值，揭示其"海洋软黄金"美誉的营养学依据。',
    content: `鲍鱼自古以来被誉为海产八珍之首，更有"海洋软黄金"的美誉。本文从营养学角度为您全面解析鲍鱼的营养价值。

## 一、基础营养成分（每100克鲜鲍鱼）

| 营养成分 | 含量 | 说明 |
|---------|------|------|
| 能量 | 77千卡 | 低热量 |
| 蛋白质 | 17.1克 | 优质完全蛋白 |
| 脂肪 | 0.8克 | 极低脂肪 |
| 碳水化合物 | 2.7克 | 低碳水 |
| 胆固醇 | 65毫克 | 适量 |
| 钠 | 322毫克 | 注意控盐 |

## 二、氨基酸组成

鲍鱼含有人体所需的全部8种必需氨基酸：

- **赖氨酸**：促进钙吸收，增强免疫力
- **亮氨酸**：促进肌肉蛋白合成
- **精氨酸**：促进伤口愈合，增强免疫力
- **牛磺酸**：保护心血管，促进婴幼儿大脑发育

## 三、矿物质含量

鲍鱼富含多种人体必需的矿物质元素：

- **锌**：每100克含1.1毫克，促进生长发育
- **硒**：每100克含32微克，强效抗氧化
- **铁**：每100克含2.4毫克，预防贫血
- **钙**：每100克含30毫克，强健骨骼
- **碘**：促进甲状腺功能

## 四、活性成分

### 鲍灵素
鲍鱼特有的活性多肽，具有免疫调节和抗肿瘤活性。

### 硫酸软骨素
有助于关节健康，缓解关节炎症状。

### EPA/DHA
虽然含量不及深海鱼类，但仍含有有益心血管健康的不饱和脂肪酸。

## 五、适宜人群

- **术后康复者**：高蛋白、低脂肪，利于伤口愈合
- **免疫力低下者**：丰富的锌、硒和活性肽增强免疫
- **亚健康人群**：补充多种微量元素
- **老年人**：预防骨质疏松和关节退化

## 六、食用禁忌

- 痛风患者慎食（嘌呤含量中等）
- 海鲜过敏者禁食
- 脾胃虚寒者不宜生食
- 不宜与富含鞣酸的食物同食（如浓茶、柿子）`,
    thumbnail: 'https://readdy.ai/api/search-image?query=Fresh%20abalone%20sashimi%20presentation%20with%20nutritional%20foods%20like%20herbs%20seaweed%20and%20citrus%20arranged%20artistically%20on%20stone%20surface%2C%20health%20and%20wellness%20concept%2C%20clean%20minimalist%20composition%2C%20soft%20natural%20lighting%2C%20wellness%20lifestyle%20photography&width=800&height=600&seq=art-yingyang-1&orientation=landscape',
    date: '2026-07-12',
    duration: '15:45',
    views: 19870,
  },
  {
    slug: 'baoyu-shiyong-kexue-zhinan',
    title: '鲍鱼食用科学指南：什么时间吃、怎么吃最营养',
    category: 'yingyang',
    categoryName: '营养科普',
    summary: '从中医食疗到现代营养学，全面解读鲍鱼的最佳食用时间、科学烹饪方式与合理食用量，让每一口都物超所值。',
    content: `鲍鱼虽好，但讲究吃法。本文结合中医食疗理论和现代营养学，为您提供最科学的鲍鱼食用指南。

## 一、最佳食用季节

### 秋冬进补
- 鲍鱼性平微温，秋冬食用最为适宜
- 中医认为秋冬进补，鲍鱼配以鸡、猪骨煨汤效果最佳
- 季节转换时适量食用可增强抵抗力

### 春夏适量
- 春夏季节也可食用，但应减少用量
- 建议清蒸、凉拌等清淡做法
- 避免过度温补导致上火

## 二、最佳食用时间

### 午餐时段（推荐）
- 上午11点至下午1点
- 此时消化功能最旺盛
- 营养吸收效率最高

### 晚餐时段
- 建议在晚上7点前食用
- 烹饪方式以清蒸为主
- 避免油炸、红烧等油腻做法

## 三、科学用量建议

- **成人**：每次50-80克（约1-2只中等鲍鱼）
- **老年人**：每次30-50克
- **儿童**（3岁以上）：每次20-30克
- **孕妇**：每周1-2次，每次50克以内
- **食用频率**：每周2-3次为宜

## 四、最佳烹饪方式

### 营养保留排行
1. 清蒸（营养保留率最高）
2. 白灼
3. 煲汤
4. 红烧
5. 油炸（营养损失最大）

### 搭配建议
- **与花菇同炖**：鲜味互补，营养加倍
- **与鸡肉同煨**：蛋白互补，滋味醇厚
- **与冬瓜同煮**：清热利水，温补不燥

## 五、食用注意事项

1. **充分加热**：避免生食或半生不熟的鲍鱼
2. **细嚼慢咽**：充分咀嚼有助消化吸收
3. **避免与鞣酸食物同食**：浓茶、柿子、山楂等
4. **痛风患者**：急性期禁食，缓解期少量
5. **高尿酸人群**：控制食用量，多饮水`,
    thumbnail: 'https://readdy.ai/api/search-image?query=Healthy%20abalone%20soup%20in%20ceramic%20bowl%20with%20medicinal%20herbs%20like%20goji%20berries%20and%20ginseng%2C%20traditional%20Chinese%20medicinal%20cuisine%2C%20warm%20steaming%20broth%2C%20wellness%20food%20photography%2C%20soft%20diffused%20lighting&width=800&height=600&seq=art-yingyang-2&orientation=landscape',
    date: '2026-06-22',
    duration: '11:30',
    views: 14320,
  },
];